import React from 'react';
import { Row, Column } from "@sm/helpers/simple-flexbox";
import FormField from "@modules/data/components/FormField";

const FormRow = (props) => {

  const {
    collapsInputsLabels,
    dataType,
    filterFields,
    index,
    lockButton,
    onSaveDataEntries,
    onValueChange,
    rowArray,
    rowForms,
    rowStyle = {}
  } = props;
  
  if (rowArray.length === 0) return <hr/>;
  
  return (
    <Row
      wrap={ true }
      horizontal="start"
      vertical="end"
      style={ rowStyle }
      className={ collapsInputsLabels ? "mid-row" : "" }
    >
      { filterFields(rowArray).map((fieldElem, elemIndex) => (
        <Column
          key={ `${ fieldElem.name }-${ elemIndex }` }
          flexGrow={ fieldElem.flexGrow || 1 }
          alignSelf={ fieldElem.alignSelf }
          vertical={ fieldElem.vertical }
          style={ fieldElem.columnStyle ? fieldElem.columnStyle : {} }
          className={ fieldElem.notInput ? "" : `input-column ${ fieldElem.fieldType === "checkBox" ? "checkbox-column" : fieldElem.fieldType === "empty" ? "empty-column" : "" } ${fieldElem.hideColumn ? 'hidden': ''}` }
        >
          <label>{ fieldElem.label }</label>
          <FormField
            fieldElem={ fieldElem }
            form={ rowForms }
            onSaveDataEntries={ onSaveDataEntries }
            onValueChange={ onValueChange }
            lockButton={ lockButton }
            index={ index }
            dataType={ dataType }
          />
        </Column>
      )) }
    </Row>
  );
};

export default FormRow;
